import get from "lodash/get";
import { pushGaProductClick, createObjForGA } from "./utils";

class CartAnalyticService {
  trackAddingToWishlist = trackData => {
    const item = get(trackData, "item", {});
    const wishlistData = get(trackData, "wishlistData", []);
    const { ecommerce, outerObj } = createObjForGA.outerAndEcommerce({
      item: {
        ...item,
        ...wishlistData
      }
    });
    pushGaProductClick.pushGaAddToWishList(ecommerce, outerObj);
  };

  trackDeleteWishlist = trackData => {
    const item = get(trackData, "item", {});
    const wishList = get(trackData, "wishList", []);
    const { ecommerce, outerObj } = createObjForGA.outerAndEcommerce({
      item: {
        ...item,
        ...wishList
      }
    });
    pushGaProductClick.pushGaRemoveFromWishList(ecommerce, outerObj);
  };

  trackAddToCart = trackData => {
    const item = get(trackData, "item", {});
    const cartData = get(trackData, "cartData", {});
    const color = get(trackData, "color", {});

    const { ecommerce, outerObj } = createObjForGA.outerAndEcommerce({
      item: { ...item, ...cartData },
      color
    });
    pushGaProductClick.pushGaAddToCart(ecommerce, outerObj);
  };

  trackRemoveFromCart = trackData => {
    const item = get(trackData, "item", {});
    const color = get(trackData, "color", {});
    const { ecommerce, outerObj } = createObjForGA.outerAndEcommerce({
      item,
      color
    });
    pushGaProductClick.pushGaRemoveFromCart(ecommerce, outerObj);
  };

  trackCartPage = trackData => {
    const data = get(trackData, "cartData.products", []);
    const { ecommerce, outerObj } =
      createObjForGA.multipleNetCoreItemsNew(data);
    pushGaProductClick.pushNTCartPage(ecommerce, outerObj);
  };

  trackRemoveFromCartInCheckout = trackData => {
    const item = get(trackData, "item", {});
    const authReducer = get(trackData, "authReducer", {});
    const commonSettings = get(trackData, "commonSettings", {});
    const productId = get(item, "trackData.productId", "");
    const title = get(item, "trackData.title", "");
    const currentPrice = get(item, "trackData.currentPrice", "");
    const brandName = get(item, "trackData.brandName", "");
    const brandId = get(item, "trackData.brandId", "");
    const email = get(authReducer, "email", "");
    const currency = get(authReducer, "currency", "");
    const countryId = get(authReducer, "countryId", "");
    const countryName = get(commonSettings, "countryName", "");
    pushGaProductClick.pushGaRemoveFromCart(
      {
        id: productId,
        product_code: productId,
        code: productId,
        name: title,
        product_name: title,
        price: currentPrice,
        brandName,
        brand: brandName,
        brandId
      },
      {
        email,
        currency,
        countryId,
        countryName
      }
    );
  };
}

export default CartAnalyticService;
